//********* NAVIGATION *********//
import * as types from "./actionTypes";

export const toggleDesktopNavigation = (desktopNavigationOpened = false) => ({
  type: types.TOGGLE_DESKTOP_NAVIGATION,
  payload: {desktopNavigationOpened}
});

export const setNavigationViewType = (navigationViewType = 3) => ({
  type: types.SET_NAVIGATION_VIEW_TYPE,
  payload: {navigationViewType}
});

export const setActiveNavigationNames = (activeNavigationParentName, activeNavigationChildName) => ({
  type: types.SET_ACTIVE_NAVIGATION_NAMES,
  payload: {activeNavigationParentName, activeNavigationChildName}
});

export const setNavigationLoading = (navigationLoadingActive) => ({
  type: types.SET_NAVIGATION_LOADING,
  payload: {navigationLoadingActive}
});

// MODULE
export const setModuleContextMenuType = (moduleContextMenuType) => ({
  type: types.SET_MODULE_CONTEXT_MENU_TYPE,
  payload: {moduleContextMenuType}
});
export const setModuleContextMenuDirection = (moduleContextMenuDirection) => ({
  type: types.SET_MODULE_CONTEXT_MENU_DIRECTION,
  payload: {moduleContextMenuDirection}
});
export const setModuleContextMenuModule = (moduleContextMenuModule) => ({
  type: types.SET_MODULE_CONTEXT_MENU_MODULE,
  payload: {moduleContextMenuModule}
});
export const setModuleContextMenuModulePart = (moduleContextMenuModulePart) => ({
  type: types.SET_MODULE_CONTEXT_MENU_MODULE_PART,
  payload: {moduleContextMenuModulePart}
});

// CABINET MODULE FILTERS
export const setActiveNavigationFilter = (activeNavigationFilter) => ({
  type: types.SET_ACTIVE_NAVIGATION_FILTER,
  payload: {activeNavigationFilter}
});
export const setActiveNavigationFilterStepIndex = (activeNavigationFilterStepIndex) => ({
  type: types.SET_ACTIVE_NAVIGATION_FILTER_STEP_INDEX,
  payload: {activeNavigationFilterStepIndex}
});
export const setCabinetNavigationFilterCompleted = (cabinetNavigationFilterCompleted) => ({
  type: types.SET_CABINET_NAVIGATION_FILTER_COMPLETED,
  payload: {cabinetNavigationFilterCompleted}
});

//COUNTERTOP WIZARD
export const setCountertopNavigationFilterCompleted = (countertopNavigationFilterCompleted) => ({
  type: types.SET_COUNTERTOP_NAVIGATION_FILTER_COMPLETED,
  payload: {countertopNavigationFilterCompleted}
});
export const setCountertopWizard = (countertopWizard) => ({
  type: types.SET_COUNTERTOP_WIZARD,
  payload: {countertopWizard}
});
export const setCabinetsApplyTo = (cabinetsApplyTo) => ({
  type: types.SET_CABINETS_APPLY_TO,
  payload: {cabinetsApplyTo}
});
export const setCabinetsApplyToBathroom = (cabinetsApplyToBathroom) => ({
  type: types.SET_CABINETS_APPLY_TO_BATHROOM,
  payload: {cabinetsApplyToBathroom}
});
export const setCountertopsApplyTo = (countertopsApplyTo, newArrayLogic = false) => ({
  type: types.SET_COUNTERTOPS_APPLY_TO,
  payload: {countertopsApplyTo, newArrayLogic}
});
export const setCountertopsApplyToBathroom = (countertopsApplyToBathroom, newArrayLogic = false) => ({
  type: types.SET_COUNTERTOPS_APPLY_TO_BATHROOM,
  payload: {countertopsApplyToBathroom, newArrayLogic}
});
export const setHandlesApplyToBathroom = (handlesApplyToBathroom) => ({
  type: types.SET_HANDLES_APPLY_TO_BATHROOM,
  payload: {handlesApplyToBathroom}
});
export const setEdgesApplyTo = (edgesApplyTo) => ({
  type: types.SET_EDGES_APPLY_TO,
  payload: {edgesApplyTo}
});

// TOGGLE DISABLED RADIO
export const toggleUpdateDisableFeatureGroupRadio = (updateDisableFeatureGroupRadio) => ({
  type: types.UPDATE_DISABLE_FEATURE_GROUP_RADIO,
  payload: {updateDisableFeatureGroupRadio}
});

// TOGGLE DISABLED RADIO
export const toggleNavItemPositionModal = (navItemPositionModal) => ({
  type: types.TOGGLE_NAV_ITEM_POSITION_MODAL,
  payload: {navItemPositionModal}
});

export const setUseFeaturesLightRequest = (useFeaturesLightRequest) => ({
  type: types.SET_USE_FEATURES_LIGHT_REQUEST,
  payload: {useFeaturesLightRequest}
});
